import React from "react"
import AirWallexLogo from "../images/airwallex-logo.jpg"
import BadenBowerLogo from "../images/BB-logo-3.png"

const Home: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-white">
      <div className="flex flex-cols items-center justify-center pt-10 max-w-xl">
        <div>
          <div className="flex justify-center items-center flex-col">
            <img src={BadenBowerLogo} alt="badenbower-logo" className="mb-5" />
          </div>

          <div className="flex flex-rows m-auto">
            <div className="w-auto border border-gray-200 px-8 py-8 rounded md:shadow-lg">
              <div className="text-red-500 text-center text-2xl pb-5">Unauthorized</div>
              <p>
                Please use the URL provided to you to access this site, if you continue to receive this
                message please contact BadenBower.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="flex justify-center items-center flex-col">
        <img src={AirWallexLogo} alt="airwallex-logo" className="mt-10" />
        <div className="font-bold text-sm m-1">
          Payment processed securely by&nbsp;
          <a
            href="https://www.airwallex.com/"
            target="_blank"
            rel="noreferrer"
            className="text-blue-700"
          >
            Airwallex
          </a>
        </div>
      </div>
    </div>
  )
}

export default Home
